import api from '@/api';
import {
  WorkOrderChartFilter,
  WorkOrderChartIndicatorResponse,
  WorkOrderChartPeriodIndicatorsResponse,
  WorkOrderChartQuantityResponse,
} from './WorkOrdersChart.types';
import { API_BASE_URL } from '..';

const CONTROLLER = `${API_BASE_URL}/workorders/chart`;

export default {
  async indicators(params?: WorkOrderChartFilter) {
    const result = (await api.get(
      `${CONTROLLER}/indicators`,
      params,
    )) as unknown;

    return result as WorkOrderChartIndicatorResponse;
  },

  async periodIndicators(params?: WorkOrderChartFilter) {
    const result = (await api.get(
      `${CONTROLLER}/period-indicators`,
      params,
    )) as unknown;

    return result as WorkOrderChartPeriodIndicatorsResponse;
  },

  async quantity(params?: WorkOrderChartFilter) {
    const result = (await api.get(
      `${CONTROLLER}/quantity-indicators`,
      params,
    )) as unknown;

    return result as WorkOrderChartQuantityResponse;
  },
};
